import type { Locale } from '$lib/i18n/types';
import type { ProfileLink } from '$routes/profile/profileLinks';
import { env } from '$env/dynamic/public';
import { addScriptTag } from '$lib/services/advertising/script';
import { matchGuardByLocaleAndDates } from '$lib/utils/matchGuards';

interface ContestConfig {
	tab: ProfileLink & {	matchGuard?: (arg: any) => boolean };
	page: {
		divId: string;
		divClass?: string;
		enabled: boolean;
		script: () => void;
		matchGuard: (locale: Locale) => boolean;
	};
	tracking: {
		context: string;
	};
}

const isContestEnabled = Boolean(env?.PUBLIC_CONTEST_ENABLED);
const [startDate, endDate, enabledLocale = 'fr-FR'] = env.PUBLIC_CONTEST_ENABLED?.split(',') || [];

function createQualifioIframe() {
	window._qual_async.push(['createIframe', 'qualifio_insert_place_1631515', 'jeu.viamichelin.com', '20', '68453B7E-EF7D-487E-B231-7B887BB2F90B', '100%', '1200', '', '', '', 'max-width:810px;margin:0 auto;']);
}

export const contest = {
	tab: {
		name: () => 'Jeu concours',
		url: 'animation',
		disabled: false,
		enabled: isContestEnabled,
		matchGuard: (locale: Locale) => matchGuardByLocaleAndDates(startDate, endDate, locale, enabledLocale as Locale),
	},
	page: {
		enabled: isContestEnabled,
		divId: 'qualifio_insert_place_1631515',
		divClass: 'qualifio_iframe_wrapper',
		matchGuard: (locale: Locale) => matchGuardByLocaleAndDates(startDate, endDate, locale, enabledLocale as Locale),
		script: () => {
			if (window._qual_async) {
				createQualifioIframe();
			} else {
				addScriptTag('qualifio', 'https://files.qualifio.com/kit/qualp.2.min.js', { loadType: 'async', onLoad: () => createQualifioIframe() });
			}
		},
	},
	tracking: {
		context: 'contest_summer_2025',
	},
} satisfies ContestConfig;
